exports = module.exports = require("../../../../web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3jS_4ho0fG6QEfb_DSEEBL{margin:0 auto;opacity:0;-webkit-transition:opacity 0.5s linear;transition:opacity 0.5s linear;background-color:#8b9fb7}._3jS_4ho0fG6QEfb_DSEEBL.loaded{opacity:1}._2EDZ2pNyuPRTY_tcvs16t1{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;margin:0 auto;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;width:100%;height:100%;padding:2rem 0;background:#8b9fb7;font-size:36px}._3KbCZUKF7Lk3z5eE5BirEw{border-radius:0}.SPfa6CkX93gI8fdTrHIDU{border-radius:50%}._3gopbd9TcjZOA_EG8EQX-e{border-radius:6px}.KHdEFRuYQrEGSB7Z5l6am{display:block;max-width:100%;height:auto}\n", ""]);

// exports
exports.locals = {
	"img": "_3jS_4ho0fG6QEfb_DSEEBL",
	"iconPlaceholder": "_2EDZ2pNyuPRTY_tcvs16t1",
	"square": "_3KbCZUKF7Lk3z5eE5BirEw",
	"circle": "SPfa6CkX93gI8fdTrHIDU",
	"rounded": "_3gopbd9TcjZOA_EG8EQX-e",
	"fluid": "KHdEFRuYQrEGSB7Z5l6am"
};